export function clean_keywords(keywords: string): string[] {

    var result = keywords.split(/[\s,]+/)
    result = result.filter( word => word)
  
    return result
  
  }